import React from 'react'
import ButtonArrow from '../../Includes/Button/ButtonArrow'
import TableCellField from '../../Includes/Table/TableCellField'
import TableCellTitre from '../../Includes/Table/TableCellTitre'
import TableCellTitreUser from '../../Includes/Table/TableCellTitreUser'
import TableMobileRowTitre from '../../Includes/Table/TableMobileRowTitre'
import TableCellFieldCheckbox from '../../Includes/Table/TableCellFieldCheckbox'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Select
} from '../../../Functions/Table'
import {
  SELECTED_USERS
} from '../../../Redux/Actions/Users'

const UsersMobileTitre = ({
  item,
  type,
  expanded,
  setExpanded
}) => {
  const dispatch = useDispatch()
  const selected = useSelector(state => state.users.selected)
  return (
    <TableMobileRowTitre
      item={item}
      type={type}
    >
      <TableCellField>
        <ButtonArrow
          expanded={expanded}
          setExpanded={setExpanded}
        />
      </TableCellField>
      <TableCellTitre
        onClick={() => setExpanded(!expanded)}
      >
        <TableCellTitreUser
          item={item}
          type={type}
          long={true}
        />
      </TableCellTitre>
      <TableCellFieldCheckbox
        checked={(selected.includes(item.id))}
        onClick={() => Select(dispatch, SELECTED_USERS, selected, item.id)}
      />
    </TableMobileRowTitre>
  )
}

export default UsersMobileTitre
